import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog, details, grid, markdown } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { editIcon, deleteIcon, addIcon, close, web, address, provisionIcon, yellowTick, expandIcon, collapseIcon } from '../../utilities/icons';
import { cache } from 'lit/directives/cache.js';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validatePhone, releaseFormLockwithBeacon, languages } from '../../utilities/formsUtilities';
import { processLocationData } from '../../utilities/locationUtilities';
import { getStatus } from '../../utilities/orgUtilities';
import { locationTypes } from '../../utilities/locationUtilities';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { AllInLocationsBase } from '../Utilities/AllInLocationsBase';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationLocationForm extends AllInSessionStorage(AllInLocationsBase(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        ...super.properties,
        _locData: { state: true, type: Array },
        _draftLocData: { state: true, type: Array },
        _provisionData: { state: true, type: Object },
        _isFormLocked: { state: true, type: Boolean },
        publishedStatus: { type: String }
    };
    constructor() {
        super();
        this._locData = [];
        this._draftLocData = [];
        this._provisionData = {};
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        //this.formID = `${this.location}-location-form`;
        this.formID = this.location?.id ? `${this.location.id}-location-form` : null;
        this.uid = `location-form-${this.organisationData.user.id}`;
        this.renderRoot.querySelector('a')?.focus();
        this.eventManager.listen(`allin-location-go-back-${this.name}`, this._handleGoBack);
        await this._setLocData();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID, this.uid, this.restUrl, this.nonce);
    }
    async _afterContextUpdate() {
        // await this._setLocData();
    }
    async firstUpdated() {
        //this._isFormLocked = await checkFormLock(this.formID,this.uid,this.restUrl,this.nonce);
        if (this.formID) {
            this._isFormLocked = await checkFormLock(this.formID, this.uid, this.restUrl, this.nonce);
        }
        addEventListener('visibilitychange', (event) => {
            if (document.visibilityState === 'hidden') {
                releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
            }
        });
        if (this.view) {
            let name = '';
            if (this.view == 'preview') {
                name = `Gwedd rhestru`;
            }
            else if (this.view == 'edit') {
                name = `Golygu manylion ${this.location.name}`;
            }
            else {
                if (this.view == 'zones' || this.view && this.view != 'edit' && this.view != 'preview') {
                    name = `Rheoli parthau ar gyfer ${this.location.name}`;
                }
            }
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name}` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Lleoliadau` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}`, title: decodeEntities(this.location.name) },
                view: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}/${this.view}`, title: name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        }
        if (this.view) {
            let name = '';
            if (this.view == 'preview') {
                name = `Gwedd rhestru`;
            }
            else if (this.view == 'edit') {
                name = `Golygu manylion ${this.location.name}`;
            }
            else {
                if (this.view == 'zones' || this.view && this.view != 'edit' && this.view != 'preview') {
                    name = `Rheoli parthau ar gyfer ${this.location.name}`;
                }
            }
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name} Dangosfwrdd` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Lleoliadau` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}`, title: decodeEntities(this.location.name) },
                view: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}/${this.view}`, title: name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        }
    }
    async updated(changedProperties) {
        if (changedProperties.has('view')) {
            if (this.view == 'edit') {
                lockForm(this.formID, this.uid, this.restUrl, this.nonce);
                this.renderRoot.querySelector('input')?.focus();
            }
            else {
                this.renderRoot.querySelector('a')?.focus();
            }
        }
    }
    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        let main = '';
        let navigation = html `<div class="buttons">\n                <button id="details" class="btn change_view ${!this.view || this.view == 'edit' ? 'active' : ''}" @click=${this._handleChangeView} aria-pressed="${!this.view || this.view == 'edit' ? 'true' : 'false'}">\n                    Manylion y lleoliad\n                    ${!this.view || this.view == 'edit' ? html `<span class="screen-reader-text"> (Tudalen bresennol)</span>` : ''}\n                </button>\n                <button id="zones" class="btn change_view ${this.view == 'zones' || this.view && this.view != 'preview' && this.view != 'edit' ? 'active' : ''}" @click=${this._handleChangeView} aria-pressed="${this.view == 'zones' || this.view && this.view != 'preview' && this.view != 'edit' ? 'true' : 'false'}">\n                    Rheoli parthau\n                    ${this.view == 'zones' || this.view && this.view != 'preview' && this.view != 'edit' ? html `<span class="screen-reader-text"> (Tudalen bresennol)</span>` : ''}\n                </button>\n                <button id="preview" class="btn change_view ${this.view == 'preview' ? 'active' : ''}" @click=${this._handleChangeView} aria-pressed="${this.view == 'preview' ? 'true' : 'false'}">\n                    Gweld rhagolwg o\u2019ch tudalen gyhoeddus\n                    ${this.view == 'preview' ? html `<span class="screen-reader-text"> (Tudalen bresennol)</span>` : ''}\n                </button>\n            </div>\n            `;
        if (!this._locData || this._locData.length == 0) {
            this._setLocData();
            main = html `<allin-loader loading></allin-loader>`;
        }
        else if (this.view == 'edit') {
            let data = this._draftLocData.length > 0 ? this._draftLocData : this._locData;
            if (this._isFormLocked) {
                main = html `\n                    <h2 class="h3-before">${decodeEntities(this.location.name)} manylion</h2>\n                    ${navigation}\n                    <div class="bg">\n                        <div class="message notice" aria-live="polite">\n                            <p>Mae aelod arall o\u2019r sefydliad hwn wrthi\u2019n golygu\u2019r ffurflen hon</p>\n                        </div>\n                    </div>\n                `;
            }
            else {
                main = html `\n                    <h2 class="h3-before">Golygu\u2019r manylion ar gyfer  ${decodeEntities(this.location.name)}</h2>\n                    ${navigation}\n                    <form @submit=${this._handleModal}>\n                        <div class="message notice" aria-live="polite">\n                            <p>Bydd angen adolygu a chymeradwyo unrhyw newidiadau</p>\n                        </div>\n                        <div class="bg">\n                            <allin-multiloader>\n                                ${data.map((item, i) => {
                    if (item.type !== 'file')
                        return '';
                    let show = i === 0 || Object.keys(item?.value ?? {}).length > 0 ? 'show' : '';
                    let fileId = '';
                    if (item.value?.publicUrl) {
                        let pattern = /%2f([^%]*)%2f/gi;
                        let matches = pattern.exec(item.value.publicUrl);
                        if (matches && matches[1]) {
                            fileId = matches[1];
                        }
                    }
                    return html `\n                                    <div class='group ${show}'>\n                                        <div class="input-group">\n                                            <allin-image-uploader inputname="${item.name}" label ="Lanlwytho llun lleoliad" src="${item.value?.publicUrl}" labelalt="${item.name}" id="${item.name}" altrequired="${item.name}AltText" altinput="${fileId}" removeStyle="words" hide-delete ?required=${item.required} error_message="Lanlwythwch lun">\n                                            </allin-image-uploader>\n                                            <label for="${item.name}AltText">Testun amgen</label>\n                                            <p><a href='https://design102.blog.gov.uk/2022/01/14/whats-the-alternative-how-to-write-good-alt-text/' target='_blank' rel="noopener noreferrer">Gweld canllaw ar sut i ysgrifennu testun amgen (yn agor mewn tab newydd)</a></p>\n                                            <input type="text" name="${item.name}AltText" id="${item.name}AltText" data-label="${item.name} ALT text" data-table_label="ALT text " value="${item.value?.altText}">\n                                        </div>\n                                    </div>`;
                })}\n                            </allin-multiloader>\n                                ${data.map((item) => {
                    if (item.type == 'file') {
                        return '';
                    }
                    let input = '';
                    if (item.type == 'checkbox') {
                        input = html `<input type="${item.type}" id="${item.name}" name="${item.name}" ?checked=${item.value} />`;
                    }
                    else if (item.type == 'select') {
                        input = html `<select name="${item.name}" id="${item.name}" ?aria-required=${item.hasOwnProperty('required') ? true : false}>\n                                            ${item.options.map(option => html `<option value="${option.name}" ?selected=${option.name === item.value}>${option.label}</option>`)}\n                                        </select>`;
                    }
                    else if (item.type == 'multiselect') {
                        input = html `<allin-multiselect name='types' list='${JSON.stringify(locationTypes)}' value='${JSON.stringify(item.value)}' description=${`Gallwch ychwanegu un neu fwy o ffurfiau celfyddydol. Bydd yr wybodaeth hon yn ddefnyddiol i bobl pan fyddant yn chwilio am ffurf gelfyddydol benodol ar y dudalen rhestru lleoliadau.`} required></allin-multiselect>`;
                    }
                    else if (item.type == 'textarea') {
                        input = html `<allin-markdown-editor name="${item.name}" label="${item.title}" value="${item.value}"></allin-markdown-editor>`;
                        //input = html`<textarea name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="Description" maxlength="500" placeholder="${msg(`Description`)}">${decodeEntities(item.value)}</textarea>`;
                    }
                    else if (item.hasOwnProperty('required')) {
                        input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" aria-required="true" name="${item.name}" value=${decodeEntities(item.value)} />`;
                    }
                    else {
                        input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" name="${item.name}" value=${decodeEntities(item.value)} data-requiredif="${item.requiredIf}" />`;
                    }
                    return html `\n                                    <div class="input-group">\n                                        <label for="${item.name}">${item.title}${item.hasOwnProperty('required') ? '*' : ''}</label>\n                                        ${input}\n                                    </div>\n                                `;
                })} \n                                ${this.provisions.map((_provision) => {
                    let thisProvisionData = this._provisionData.find((item) => {
                        return item.title == _provision.title;
                    });
                    let icon = _provision.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                    return html `\n                                        <details class="provisions">\n                                            <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${_provision.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} />${_provision.title}</summary>\n                                            <div class="panel">\n                                                ${_provision.provisions.map((provision) => {
                        let checked, description, image, altText, imageId;
                        let index = thisProvisionData?.provisions.findIndex((item) => {
                            return item.id == provision.id;
                        });
                        let id = `provision__${provision.id}`;
                        if (index !== undefined && index !== -1) {
                            checked = true;
                            description = thisProvisionData.provisions[index].description;
                            image = thisProvisionData.provisions[index].image;
                            imageId = thisProvisionData.provisions[index].imageId;
                            altText = thisProvisionData.provisions[index].alt;
                        }
                        return html `\n                                                        <div class="provision">\n                                                            <div class="input-group">\n                                                                <label for="${id}">${provision.name}</label>\n                                                                <input type="checkbox" name="${id}" id="${id}" ?checked=${checked} data-table_label="Provision">\n                                                            </div>\n                                                                <p class="small">${provision.description}</p>\n                                                                <div class="hidden">\n                                                                    <label for="${id}_description">Os yw\u2019n ddefnyddiol, gallwch egluro sut gall pobl gael gafael ar y ddarpariaeth hon.</label>\n                                                                    <allin-markdown-editor name="${id}_description" id="${id}_description" data-label="${provision.name} description" data-table_label="Description" placeholder="Description" value="${description}"></allin-markdown-editor>\n                                                                    <allin-image-uploader inputname="${id}_photo" label ="Lanlwytho delwedd ategol (dewisol)" src="${image}" labelalt="${provision.name} supporting image" tablelabelalt="Supporting image" id="${id}" altrequired="${id}_photoAltText" altinput="${imageId}">\n                                                                    </allin-image-uploader>\n                                                                    <label for="${id}_photoAltText">Dylech gynnwys testun amgen</label>\n                                                                    <p><a href="https://design102.blog.gov.uk/2022/01/14/whats-the-alternative-how-to-write-good-alt-text/" target="_blank">Gweld canllaw ar sut i ysgrifennu testun amgen (yn agor mewn tab newydd).</a></p>\n                                                                    <input type="text" name="${id}_photoAltText" id="${id}_photoAltText" data-label="${provision.name} ALT text" data-table_label="ALT text " value="${altText}">\n                                                                </div>\n                                                                ${provision.more_info ? html `\n                                                                <allin-tooltip tooltip="${provision.more_info}"></allin-tooltip>\n                                                                ` : ''}\n                                                            </div>\n                                                        </div>\n                                                    `;
                    })}\n                                            </div>\n                                        </details>\n                                    `;
                })}\n                                <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                                <input type="hidden" name="location_id" value="${this.location.id}" />\n                                <input type="hidden" name="action" value="${this.action}-edit-location" />\n                                ${this.location.location_data.publishedStatus
                    ? html `<input type="hidden"\n                                        name="publishedStatus"\n                                        value="${this.location.location_data.publishedStatus}" />` : ''}\n\n\n                                <div class="button-group">\n                                    <button type="submit">Cadw\u2019r newidiadau a\u2019u cyflwyno i\u2019w cymeradwyo</button>\n                                </div>   \n                                <hr>\n                                <div class="loc-form-footer">\n                                    <a href="javascript:void(0)" @click=${this._handleClick} class="cancel-edit">${deleteIcon}Canslo</a>\n                                    ${this.location.location_data.publishedStatus ? html `\n                                        <div class="loc-publ-status-group">\n                                            <p class="loc-publ-status-p">\n                                                ${this.location.location_data.publishedStatus === "Published"
                    ? `Mae eich lleoliad wedi\u2019i Gyhoeddi` : `Mae eich lleoliad wedi\u2019i Ddadgyhoeddi`}\n                                            </p>\n                                            <button\n                                                type="button"\n                                                class="loc-publ-status-btn"\n                                                @click=${this._togglePublishedStatus}\n                                            >\n                                                ${this.location.location_data.publishedStatus === "Published"
                    ? `Dadgyhoeddi lleoliad` : `Cyhoeddi lleoliad`}\n                                            </button>\n                                        </div>\n                                    ` : ''}\n\n                                </div>\n                        </div>\n                    </form> \n                    <dialog>\n                        <button class="close" autofocus @click=${this._handleModal}><span aria-hidden="true">${deleteIcon}</span>Canslo</button>\n                        <p>\n                            ${this.organisation.subscriptionTier == 'Tier1' ? `Cyfrif rhagflas yw hwn, felly ni fydd eich lleoliad yn cael ei restru\u2019n fyw. Gallwch wneud newidiadau a gweld rhagolwg ohonynt o hyd drwy ddewis Cadw Newidiadau.` : `Mae eich proffil lleoliad wedi cael ei gyflwyno i\u2019n T\u00EEm Cymorth a Sgiliau ei adolygu. Fydd eich lleoliad ddim yn cael ei restru\u2019n fyw nes iddo gael ei gyhoeddi. Gallwch wneud newidiadau a gweld rhagolwg ohonynt o hyd drwy ddewis Cadw Newidiadau.`}\n                        </p>\n                        <button @click=${this._handleSubmit}>Cadw newidiadau</button>\n                    </dialog>\n                `;
            }
        }
        else if (this.view == 'preview') {
            main = html `\n                <h2 class="h2-before">${decodeEntities(this.location.name)} manylion</h2>\n                ${navigation}\n                <div class="preview--container">\n                    <allin-location location="${this.location}" organisation="${this.currentOrg}" preview="true" locationData="${JSON.stringify(this.location)}" name="${this.name}" action="${this.action}" nonce="${this.nonce}" restUrl="${this.restUrl}"/>\n                </div>\n            `;
        }
        else if (!this.view) {
            let data = this._draftLocData.length > 0 ? this._draftLocData : this._locData;
            let cta = html `<hr><a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Golygu\u2019r manylion hyn</a>`;
            let hasSchemes = false;
            if (this.location.location_data.approvalStatus == 'AwaitingResponse') {
                let message = `Diolch am gyflwyno eich lleoliad. Byddwch nawr yn gallu gweld rhagolwg o\u2019ch proffil cyhoeddus a gwneud newidiadau i\u2019ch lleoliad.`;
                if (this.organisation.subscriptionTier == 'Tier1') {
                    message = `Diolch am gyflwyno eich lleoliad. Byddwch nawr yn gallu gweld rhagolwg o\u2019ch proffil a gwneud newidiadau i\u2019ch lleoliad.`;
                }
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>${message}</p>\n                    </div> \n                    </div> \n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Golygu cyflwyniad</a>\n                `;
            }
            else if (this.location.location_data.approvalStatus == 'NewApplication') {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>Dydy eich cais ddim wedi cael ei gyflwyno eto</p>\n                    </div>\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Golygu cyflwyniad</a>\n                    `;
            }
            let loop = [];
            let websiteD = data.find((item) => item.name == 'website');
            if (websiteD.value) {
                loop.push(html `<div class="grid grid--icon">\n                        <div class="icon">${web}</div>\n                        <div class="icon_text">\n                            <h3 class="p-before"><strong>Gwefan:</strong></h3>\n                            <p><a href="${websiteD.value}" target="_blank">${websiteD.value}</a></p>\n                        </div>\n                    </div>`);
            }
            let addressD = [
                data.find((item) => item.name == 'address1'),
                data.find((item) => item.name == 'address2'),
                data.find((item) => item.name == 'city'),
                data.find((item) => item.name == 'country'),
                data.find((item) => item.name == 'postcode'),
            ];
            if (addressD[0].value) {
                loop.push(html `<div class="item grid grid--icon">\n                        <div class="icon">${address}</div>\n                        <div class="text">\n                            <h3 class="p-before"><strong>Cyfeiriad:</strong></h3>\n                            <address>\n                            ${addressD.map(item => html `<p>${item.value}</p>`)}\n                            </address>\n                        </div>\n                    </div>`);
            }
            let phoneD = data.find((item) => item.name == 'phone');
            if (phoneD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Ff\u00F4n:</strong></h3>\n                        <p>${phoneD.value}</p>\n                    </div>`);
            }
            let emailD = data.find((item) => item.name == 'email');
            if (emailD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>E-bost:</strong></h3>\n                        <p>${emailD.value}</p>\n                    </div>`);
            }
            let languageD = data.find((item) => item.name == 'language');
            if (languageD.value) {
                loop.push(html `<div class="item text">\n                    <h3 class="p-before"><strong>Iaith:</strong></h3>\n                    <p>${languages[languageD.value]}</p>\n                    `);
            }
            let descriptionD = data.find((item) => item.name == 'description');
            if (descriptionD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Disgrifiad:</strong></h3>\n                        <allin-markdown-editor .value=${decodeEntities(descriptionD.value)} readonly></allin-markdown-editor>\n                    </div>`);
            }
            let typeD = data.find((item) => item.name == 'type');
            if (typeD.value && typeD.value.length > 0) {
                let types = typeD.value.map((type) => {
                    let typeData = locationTypes.find((t) => t.name === type);
                    return typeData ? typeData.label : type;
                });
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Math:</strong></h3>\n                        <p>${types.join(', ')}</p>\n                    </div>`);
            }
            let accessInformationD = data.find((item) => item.name == 'accessInformation');
            if (accessInformationD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>URL gwybodaeth am fynediad:</strong></h3>\n                        <p><a href="${accessInformationD.value}" target="_blank">${accessInformationD.value}</a></p>\n                    </div>`);
            }
            let visualStoryD = data.find((item) => item.name == 'visualStory');
            if (visualStoryD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>URL Stori Weledol:</strong></h3>\n                        <p><a href="${visualStoryD.value}" target="_blank">${visualStoryD.value}</a></p>\n                    </div>`);
            }
            let accessAbleD = data.find((item) => item.name == 'accessAble');
            if (accessAbleD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Proffil AccessAble:</strong></h3>\n                        <p><a href="${accessAbleD.value}" target="_blank">${accessAbleD.value}</a></p>\n                    </div>`);
            }
            let euansGuideD = data.find((item) => item.name == 'euansGuide');
            if (euansGuideD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Proffil Euan\u2019s Guide:</strong></h3>\n                        <p><a href="${euansGuideD.value}" target="_blank">${euansGuideD.value}</a></p>\n                    </div>`);
            }
            let videoUrlD = data.find((item) => item.name == 'videoUrl');
            let videoDescriptionD = data.find((item) => item.name == 'videoDescription');
            if (videoUrlD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>URL Fideo:</strong></h3>\n                        <p><a href="${videoUrlD.value}" target="_blank">${videoUrlD.value}</a></p>\n                        ${videoDescriptionD.value ? html `<p>${videoDescriptionD.value}</p>` : ''}\n                    </div>`);
            }
            let requiresProofOfEligibilityD = data.find((item) => item.name == 'requiresProofOfEligibility');
            if (requiresProofOfEligibilityD.value) {
                loop.push(html `<div class="item text">\n                        <h3 class="p-before"><strong>Angen prawf o gymhwysedd:</strong></h3>\n                        <p>${yellowTick}Iawn</p>\n                    </div>`);
            }
            let allInSchemeD = data.find((item) => item.name == 'allInScheme');
            if (allInSchemeD.value) {
                if (!hasSchemes) {
                    loop.push(html `<h3 class="p-before"><strong>Cynlluniau</strong></h3>`);
                    hasSchemes = true;
                }
                loop.push(html `<div class="item text">\n                        <p>${yellowTick}I Bawb</p>\n                    </div>`);
            }
            let acceptNimbusCardD = data.find((item) => item.name == 'acceptNimbusCard');
            if (acceptNimbusCardD.value) {
                if (!hasSchemes) {
                    loop.push(html `<h3 class="p-before"><strong>Cynlluniau</strong></h3>`);
                    hasSchemes = true;
                }
                loop.push(html `<div class="item text">\n                        <p>${yellowTick}Derbyn Cerdyn Mynediad</p>\n                    </div>`);
            }
            let acceptCeaCardD = data.find((item) => item.name == 'acceptCeaCard');
            if (acceptCeaCardD.value) {
                if (!hasSchemes) {
                    loop.push(html `<h3 class="p-before"><strong>Cynlluniau</strong></h3>`);
                    hasSchemes = true;
                }
                loop.push(html `<div class="item text">\n                        <p>${yellowTick}Derbyn Cerdyn CEA</p>\n                    </div>`);
            }
            let acceptSunflowerLanyardD = data.find((item) => item.name == 'acceptSunflowerLanyard');
            if (acceptSunflowerLanyardD.value) {
                if (!hasSchemes) {
                    loop.push(html `<p><strong>Cynlluniau</strong></p>`);
                    hasSchemes = true;
                }
                loop.push(html `<div class="item text">\n                        <p>${yellowTick}Derbyn Laniardiau Blodau\u2019r Haul</p>\n                    </div>`);
            }
            let photo1D = data.find((item) => item.name == 'photo1');
            let photo2D = data.find((item) => item.name == 'photo2');
            let photo3D = data.find((item) => item.name == 'photo3');
            if (photo1D.value || photo2D.value || photo3D.value) {
                loop.push(html `<h3 class="p-before gallery"><strong>Oriel</strong></h3>`);
                if (photo1D.value && photo1D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo1D.value.publicUrl}" alt="${photo1D.value.altText}" width="200px" />\n                            <div class="text">\n                                <h4 class="p-before"><strong>ALT text</strong></h4>\n                                <p>${photo1D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo2D.value && photo2D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo2D.value.publicUrl}" alt="${photo2D.value.altText}" width="200px" />\n                            <div class="text">\n                                <h4 class="p-before"><strong>ALT text</strong></h4>\n                                <p>${photo2D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo3D.value && photo3D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo3D.value.publicUrl}" alt="${photo3D.value.altText}" width="200px" />\n                            <div class="text">\n                                <h4 class="p-before"><strong>ALT text</strong></h4>\n                                <p>${photo3D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
            }
            let provisionsLoop = this._provisionData.map((item) => {
                let markup = [];
                let hasDraft = false;
                item.provisions.forEach((provision) => {
                    let isDraft = provision.draft == true;
                    if (isDraft) {
                        hasDraft = true;
                    }
                    markup.push(html `\n                               \n                                <div class="provision item grid grid--icon ${isDraft ? 'draft' : ''}">\n                                    <div class="icon"><span aria-hidden="true">${yellowTick}</span><span class="screen-reader-text">${provision.name} is available</span></div>\n                                    <div class="text">\n                                        <p><strong>${provision.name}</strong> ${isDraft ? html `<span class="is_draft">Yn aros am gymeradwyaeth</span>` : ''}</p>\n                                        <allin-markdown-editor readonly value="${provision.description}"></allin-markdown-editor>\n                                        ${provision.image ? html `<img width="200" height="130" src="${provision.image}" alt="${provision.alt}" />` : ''}\n                                    </div>\n                                </div>\n                                    \n                            `);
                });
                if (markup.length == 0) {
                    return '';
                }
                let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                return html `\n                         <details class="provisions">\n                            <summary>\n                                <img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                    e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                } }} />\n                                <span>${item.title}</span>\n                                ${hasDraft ? html `<p class="has_draft">Mae gan y ddarpariaeth hon newidiadau sy\u2019n aros i gael eu cymeradwyo</p>` : ''}\n                            </summary>\n                            <div class="panel">\n                                ${markup}\n                            </div>\n                        </details>\n                        `;
            });
            let hasProvisions = provisionsLoop.filter((item) => item != '');
            let provisionsPre = '';
            if (hasProvisions.length == 0) {
                provisionsPre = html `<p class="small">Does dim darpariaethau wedi\u2019u hychwanegu at y lleoliad hwn eto neu efallai eu bod yn aros i gael eu cymeradwyo</p>`;
            }
            else {
                provisionsPre = html `<div class="collapsers">\n\t\t\t\t\t<button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Ehangu pob darpariaeth</button>\n\t\t\t\t\t<button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Crebachu pob darpariaeth</button>\n\t\t\t\t</div>`;
            }
            main = html `\n                <h2 class="h3-before">${decodeEntities(this.location.name)} manylion</h2>\n                ${navigation}\n                <div class="bg">\n                    ${loop} \n                    ${provisionsPre}\n                    ${provisionsLoop}\n                    ${cta}   \n                </div>\n            `;
        }
        else {
            let location = this.location.location_data;
            let zones = location.zones;
            let zonesText = '';
            let action = '';
            if (location.approvalStatus == "Approved") {
                let hasInProgressZones = zones.some(zone => zone.in_progress);
                let subscriptionExpired = this.organisation.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) < new Date();
                let hasActiveSubscription = this.organisation.subscriptionTier && this.organisation.subscriptionTier !== 'Tier1' && !subscriptionExpired;
                if (zones.length > 0) {
                    zonesText = html `\n                        <h4>Zones</h4>\n                        <ul class="zone-list bg">\n                            ${zones.map((zone, index) => {
                        let link;
                        let status = getStatus(zone.approvalStatus);
                        if (zone.in_progress) {
                            link = html `<a href="${this.hardlinks.organisation_dashboard_add_zone}?org_id=${this.currentOrg}&location_id=${this.location.id}&in_progress=${zone.id}&ppage=${zone.in_progress}">Cwblhau\u2019r broses o osod eich parth</a>`;
                        }
                        else {
                            link = html `<a href="javascript:void(0)" data-zone_id="${zone.id}" data-location_id="${this.location.id}" data-org_id="${this.currentOrg}" @click=${this._handleZoneClick}>Rheoli</a>`;
                        }
                        return html `\n                                <li>\n                                    ${zone.name} \n                                    ${status ? html `<span class="message small">${status}</span>` : ''}\n                                    ${link}\n                                </li>\n                            `;
                    })}\n                        </ul>\n                    `;
                }
                if (this.view == 'zones') {
                    action = !hasInProgressZones && hasActiveSubscription ? html `\n                            <div class="button-group">\n                                <a href="/organisation-dashboard/add-zone?org_id=${this.currentOrg}&location_id=${this.location.id}" class="button">${zones.length ? `Ychwanegu parth arall` : `Ychwanegu parth`}</a>\n                            </div>\n                        ` : '';
                    if (!hasActiveSubscription) {
                        action = html `\n                            <div class="message notice" aria-live="polite">\n                                <p>Mae angen tanysgrifiad gweithredol arnoch i ychwanegu parthau. Cysylltwch \u00E2\u2019r t\u00EEm cymorth i uwchraddio eich tanysgrifiad.</p>\n                                <button class="button" @click=${() => this._updateContext({ dashboard: 'subscriptions', panel: null, view: null })}>Gweld opsiynau tanysgrifio</button>\n                            </div>\n                        `;
                    }
                }
                else {
                    action = html `<allin-organisation-zone-form\n                    zoneId=${this.view}\n                    locationId=${this.location.id}\n                    currentOrg=${this.currentOrg}\n                ></allin-organisation-zone-form>`;
                }
                main = html `\n                    <h2 class="h3-before">Parthau ar gyfer  ${decodeEntities(this.location.name)}</h2>\n                    ${navigation}\n                    ${zonesText}\n                    ${action}\n                `;
            }
            else {
                main = html `\n                    <h2 class="h3-before">Parthau ar gyfer  ${decodeEntities(this.location.name)}</h2>\n                    ${navigation}\n                    <p>Rhaid i\u2019ch lleoliad gael ei gymeradwyo cyn i chi allu ychwanegu parthau</p>\n                `;
            }
        }
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        let view = this.view == 'edit' ? '' : 'edit';
        this._handleChangeView(null, view);
    }
    _handleGoBack() {
        this._handleChangeView(null, '');
    }
    _handleChangeView(e, view = null) {
        if (e) {
            e.preventDefault();
            let button = e.target;
            view = button.id;
            if (view == 'details') {
                view = '';
            }
        }
        let oldView = this.view;
        this.view = view;
        if (this.view == oldView) {
            return;
        }
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/locations/' + this.location.id + '/' + this.view, { panel: this.location.id, view: this.view });
        if (!this.view && oldView) {
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name}` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Lleoliadau` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}`, title: decodeEntities(this.location.name) },
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
            if (oldView == 'preview') {
                this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
            }
        }
        else if (this.view) {
            let name = '';
            if (this.view == 'preview') {
                name = `Gwedd rhestru`;
            }
            else if (this.view == 'edit') {
                name = `Golygu manylion ${this.location.name}`;
            }
            else {
                if (this.view == 'zones' || this.view && this.view != 'edit' && this.view != 'preview') {
                    name = `Rheoli parthau ar gyfer ${this.location.name}`;
                    if (oldView == 'preview') {
                        this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
                    }
                    else if (oldView == 'zones' || oldView && oldView != 'edit' && oldView != 'preview') {
                        return;
                    }
                }
            }
            let crumb = {
                organisation: { url: `/organisation-dashboard/${this.currentOrg}`, title: `${this.organisation.name}` },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/locations`, title: `Lleoliadau` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}`, title: decodeEntities(this.location.name) },
                view: { url: `/organisation-dashboard/${this.currentOrg}/locations/${this.location.id}/${this.view}`, title: name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
            this._updateContext({ view: this.view });
        }
    }
    _handleModal(e) {
        e.preventDefault();
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    _handleZoneClick(e) {
        e.preventDefault();
        const zoneId = e.currentTarget.dataset.zone_id;
        this._handleChangeView(null, zoneId);
    }
    async _handleSubmit(e) {
        e.preventDefault();
        this._modal.close();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                let data = JSON.parse(response.data);
                let locIndex = this.organisation.locations.findIndex(loc => loc.id == data.location_id);
                data.id = data.location_id;
                data.name = data.location_name;
                this.organisation.locations[locIndex] = { ...data };
                this.location = { ...data };
                this._updateContext({ location: this.location });
                this._setLocationProvisionsToSessionStorage();
                this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
                ({ locData: this._locData, draftLocData: this._draftLocData, provisionData: this._provisionData } = processLocationData({ ...data }));
                submitButton.disabled = false;
                this.view = false;
            }
            else {
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
                this._setExpiry(`allin_location_${this.location.id}_provisions`, 0);
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    async _setLocData(refresh = false) {
        if (!this.organisation) {
            return;
        }
        let neededFetch = false;
        if (!this.organisation.locations) {
            await this._fetchLocations();
            neededFetch = true;
        }
        this.location = this._getLocationById(this.panel);
        if (!this.location.location_data) {
            await this._fetchLocations();
            this.location = this._getLocationById(this.panel);
        }
        this._updateContext({ location: this.location });
        this.publishedStatus = !!this.location.publishedStatus;
        if (!this.location) {
            console.warn(`Location not found for ID: ${this.location}`);
            this.location = {};
            return;
        }
        if (!this.location.provisions || refresh) {
            this._getLocationProvisionsFromSessionStorage(this.location.id);
            if (!this.location.provisions || refresh || neededFetch) {
                await this._fetchProvisions();
            }
        }
        if (!this.provisions.length) {
            this._getProvisionsFromSessionStorage();
            if (!this.provisions.length) {
                await this._fetchAllProvisions();
            }
        }
        let processedData = processLocationData(this.location);
        if (processedData) {
            ({ locData: this._locData, draftLocData: this._draftLocData, provisionData: this._provisionData } = processedData);
        }
        else {
            this.location = {};
            this._updateContext({ location: this.location });
        }
    }
    async _fetchAllProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions-all&nonce=${this.nonce}`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this.provisions = data.provisions;
            this._loading = false;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { provisions: JSON.stringify(this.provisions) });
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    async _fetchLocations() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-locations&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.organisation.locations = data.locations;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions&location_id=${this.location.id}&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.location.provisions = data.provisions;
            this._setLocationProvisionsToSessionStorage();
            this.organisation.locations.provisions = data.provisions;
            this._updateContext({ location: this.location, organisation: this.organisation });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _handleCollapse(e) {
        let target = e.currentTarget.dataset.collapse;
        if (target) {
            let targets = this.shadowRoot.querySelectorAll(`.${target}`);
            if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                targets.forEach(target => target.classList.remove('open'));
            }
            else {
                e.currentTarget.setAttribute('aria-expanded', 'true');
                targets.forEach(target => target.classList.add('open'));
            }
        }
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    async _togglePublishedStatus() {
        this.location.location_data.publishedStatus =
            this.location.location_data.publishedStatus === "Published" ? "Archived" : "Published";
        // Update hidden input
        const input = this._form.querySelector('[name="publishedStatus"]');
        if (input) {
            input.value = this.location.location_data.publishedStatus;
        }
        // Update location publishedStatus p tag
        const pText = this._form.querySelector('p.loc-publ-status-p');
        if (pText) {
            pText.textContent =
                this.location.location_data.publishedStatus === "Published"
                    ? "Your location is Published"
                    : "Your location is Unpublished";
            ;
        }
        // Update the location publishedStatus button label
        const toggleBtn = this.renderRoot.querySelector('button.loc-publ-status-btn');
        if (toggleBtn) {
            toggleBtn.textContent =
                this.location.location_data.publishedStatus === "Published"
                    ? "Unpublish location"
                    : "Publish location";
        }
        //The long commented-out snippet below is for testing LOCATION PUBLISHED STATUS AND SEE IF IT GETS PASSED TO DRAFT FIRST BEFORE GETTING TO THE ORG LOCATION DATA
        try {
            // Send the POST request
            const response = await fetch(this.restUrl, {
                method: 'POST',
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action: 'update-location-published-status',
                    org_id: this.currentOrg,
                    location_id: this.location.id,
                    publishedStatus: this.location.location_data.publishedStatus
                }),
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            // Parse JSON response
            const result = await response.json();
            if (result.ok) {
                this.organisation.locations = result.data;
                this._updateContext({ organisation: JSON.stringify(this.organisation) });
            }
            else {
                console.error(result.message || 'Update failed');
            }
        }
        catch (err) {
            console.error('Error updating location:', err);
        }
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }
        
        .bg .loc-form-footer{
            overflow:hidden;
        }

        .bg a.cancel-edit{
            display: inline-block;
            vertical-align: top;
        }

        .bg a.cancel-edit svg{
            vertical-align: top;
        }

        .bg .loc-publ-status-group{
            display: inline-block;
            vertical-align: top;
            float: right;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }

        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
            background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            font-weight: var(--allin-button-font-weight, 600);
            color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            box-sizing: border-box;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
            padding-top: 1.5rem;
            display: inline-block;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        h2.h3-before{
            font-size: 1.17em;
        }

        h3.p-before{
            margin: 0 0 0.2em 0;
            font-weight: normal;
            font-size: 1rem;
        }
        h3.p-before.gallery{
            margin-bottom: 1rem;
        }

        h4.p-before{
            margin: 0 0 0.2em 0;
        }
        ul.zone-list {
            list-style:none;
            margin:0;
        }
        ul.zone-list li {

            display:grid;
            gap:0.5rem;
            grid-template-columns: 1fr auto;
            border-top: 1px solid gray;
            border-bottom: 1px solid gray;
            padding: 0.5rem 0;
            font-weight: bold;
        }
        ul.zone-list li .message {
            grid-row: 2 / 3;
            grid-column: 1 / -1;
            font-weight: 400;
        }
        ul.zone-list li a {
            justify-self: end;
            font-size: 0.9rem;
        }
        .add_uploader{
            svg path{
                fill:#fff;
            }
            &:hover{
                svg path{
                    fill:var(--allin-highlight-color,#472961);
                }
            }
        }

        .has_draft{
            font-weight:400;
            font-size:1rem;
            color:#555;
            grid-column:1 / -1;
        }

        .is_draft{
            font-weight:400;
            font-size:1rem;
            color:#555;
        }

        p:has(.is_draft){
            display:flex;
            justify-content:space-between;
        }
        allin-multiloader{
            margin-bottom: 2rem;
            display: block;
        }
        `
    ];
}
